import React, {
    PropTypes,
} from 'react';
import {Glyphicon} from 'react-bootstrap';

const MenuSummary = ({wares}) => {
    const {cost, calories, weight} = wares.reduce((res, ware) => {
        const {waresQuantity, /*calorie,*/ cost/*, weight*/} = ware;
        if (waresQuantity > 0) {
            res.cost += cost * waresQuantity;
            // const cal = parseFloat(calorie);
            // res.calories += !isNaN(cal) ? cal * waresQuantity : 0;
            // const w = parseFloat(weight);
            // res.weight += !isNaN(w) ? w * waresQuantity : 0;
        }

        return res;
    }, {
        cost: 0,
        calories: 0,
        weight: 0,
    });
    return (
        <div className="col-sm-6" style={{
            lineHeight: "33px",
        }}>
            Итого:&nbsp;&nbsp;
            <Glyphicon glyph="piggy-bank"/>&nbsp;{cost.toFixed(2)}грн.&nbsp;&nbsp;
            {weight ? (<span><Glyphicon glyph="scale"/>&nbsp;{weight}г.&nbsp;&nbsp;</span>) : ''}
            {calories ? (<span><Glyphicon glyph="fire"/>&nbsp;{calories}cal</span>) : ''}
        </div>
    );
};

MenuSummary.propTypes = {
    wares: PropTypes.array.isRequired,
};

export default MenuSummary;



/** WEBPACK FOOTER **
 ** ./src/modules/food/MenuSummary.js
 **/